import api from "../api/flexapi";

export const GET_OTHER_BENEFITS_START = "GET_OTHER_BENEFITS_START";
export const GET_OTHER_BENEFITS_SUCCESS = "GET_OTHER_BENEFITS_SUCCESS";
export const GET_OTHER_BENEFITS_ERROR = "GET_OTHER_BENEFITS_ERROR";
export const POST_OTHER_BENEFITS_START = "POST_OTHER_BENEFITS_START";
export const POST_OTHER_BENEFITS_SUCCESS = "POST_OTHER_BENEFITS_SUCCESS";
export const POST_OTHER_BENEFITS_ERROR = "POST_OTHER_BENEFITS_ERROR";
export const SELECT_PLAN = "SELECT_PLAN";
export const TOGGLE_SHOW_MORE_OTHER = "TOGGLE_SHOW_MORE_OTHER";

const getSelectedPlans = members => {
  return members.map(mem => {
    const selectedPlan = mem.plans.find(x => x.isSelected);
    return {
      memberKey: mem.memberKey,
      memberType: mem.memberType,
      planId: selectedPlan ? selectedPlan.id : null, // Handle case where no plan is selected
    };
  });
};

const formatOtherBenefitsForSave = otherBenefitsData => {
  const data = [];
  otherBenefitsData.forEach(acc => {
    acc.otherBenefits.forEach(ben => {
      const benefitId = ben.id;
      const flexPlanId = acc.flexPlanId;
      const selected = getSelectedPlans(ben.members);
      data.push({ benefitId, flexPlanId, selected });
    });
  });
  return data;
};

export const setSelectedPlan = (accountId, benefitId, memberKey, plan) => dispatch => {
  dispatch({ type: SELECT_PLAN, payload: { accountId, benefitId, memberKey, plan } });
};

export const toggleShowMore = (accountId, benefitId) => dispatch => {
  dispatch({ type: TOGGLE_SHOW_MORE_OTHER, payload: { accountId, benefitId } });
};

export const getOtherBenefits = () => dispatch => {
  dispatch({ type: GET_OTHER_BENEFITS_START });

  api
    .getOtherBenefits()
    .then(response => {
      dispatch({
        type: GET_OTHER_BENEFITS_SUCCESS,
        payload: response.body,
      });
    })
    .catch(err => {
      dispatch({
        type: GET_OTHER_BENEFITS_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const saveOtherBenefits = (data, postSuccessHandler) => dispatch => {
  dispatch({ type: POST_OTHER_BENEFITS_START });
  const payload = formatOtherBenefitsForSave(data);
  api
    .postOtherBenefits(payload)
    .then(response => {
      dispatch({
        type: POST_OTHER_BENEFITS_SUCCESS,
        payload: response.body,
      });
      postSuccessHandler();
    })
    .catch(err => {
      dispatch({
        type: POST_OTHER_BENEFITS_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};



// WEBPACK FOOTER //
// ./actions/otherBenefitsActions.js